import type { ResourceKind, ResourceStatus } from './resourceEnum';

export class ResourceEvent extends Event {
  readonly id: string;
  readonly kind: ResourceKind;
  readonly status: ResourceStatus;

  constructor(
    type: 'resourcechange' | 'resourceerror',
    id: string,
    kind: ResourceKind,
    status: ResourceStatus,
  ) {
    super(type);
    this.id = id;
    this.kind = kind;
    this.status = status;
  }

  get buildTime() {
    return this.id;
  }
}
